import { idSchema } from "@reactive-resume/schema";
import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

export const deleteCoverLetterSchema = z.object({
  id: idSchema,
});

export class DeleteCoverLetterDto extends createZodDto(deleteCoverLetterSchema) {}
